import { Injectable } from '@angular/core';
import type { AttachmentRecord } from '../attachments-panel/attachments-panel.component';

export interface AttachmentViewerHost {
  open(attachment: AttachmentRecord): void;
}

/**
 * Opens the app-wide attachment viewer from anywhere — a list row, a table
 * cell, or a panel nested inside another modal — without the caller holding a
 * template reference. The viewer component registers itself from the app root.
 */
@Injectable({ providedIn: 'root' })
export class AttachmentViewerService {
  private host: AttachmentViewerHost | null = null;

  register(host: AttachmentViewerHost): void {
    this.host = host;
  }

  unregister(host: AttachmentViewerHost): void {
    if (this.host === host) this.host = null;
  }

  open(attachment: AttachmentRecord): void {
    if (!this.host) {
      console.warn('[attachment-viewer] no viewer is mounted; add <mac-attachment-viewer /> to the app root');
      return;
    }
    this.host.open(attachment);
  }
}
